import { IDropdownItem } from "components/dropdown/dropdown.interface";

export const languageDropdown: IDropdownItem[] = [
    { label: 'ENGLISH - (UK)', value: 'uk' },
    { label: 'INDONESIA - (IND)', value: 'ind' },
    { label: 'JAPAN - (JP)', value: 'jp' },
]